import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { gettext } from '../../i18n/service.js';
import * as actions from '../../actions/dashboardPageActions';

class MarkerCategoryModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showOrderOption: props.showOrderOption
    };
  }
  changeCategoryState(category, value) {
    this.props.changeCategoryState();
    let { showOrderOption } = this.props;
    showOrderOption[category] = value;
    this.props.actions.setMapFilter(showOrderOption);
    this.setState({showOrderOption: showOrderOption});
  }
  render() {
    return (
      <div className="markerCategoryModal" style={{zIndex: this.props.upCategoryIndex?100:100000, display: this.props.showModal?'block':'none',  bottom: this.props.fullSize ? 'calc(130px + 100% - 100vh)' : '80px'}}>
        <div>
          <p className="title">Orders</p>
          <p><input type="checkbox" checked = {this.state.showOrderOption.unassigned} onChange={e => this.changeCategoryState('unassigned', !this.props.showOrderOption.unassigned)}/> {gettext('UNASSIGNED')}</p>
          <p><input type="checkbox" checked = {this.state.showOrderOption.assigned} onChange={e => this.changeCategoryState('assigned', !this.props.showOrderOption.assigned)}/> {gettext('ASSIGNED')}</p>
          <p><input type="checkbox" checked = {this.state.showOrderOption.deliveryPoint} onChange={e => this.changeCategoryState('deliveryPoint', !this.props.showOrderOption.deliveryPoint)}/> {gettext('DELIVERY-POINT')}</p>
          <p><input type="checkbox" checked = {this.state.showOrderOption.pickupPoint} onChange={e => this.changeCategoryState('pickupPoint', !this.props.showOrderOption.pickupPoint)}/> {gettext('PICKUP-POINT')}</p>
          <p><input type="checkbox" checked = {this.state.showOrderOption.waitingForPickup} onChange={e => this.changeCategoryState('waitingForPickup', !this.props.showOrderOption.waitingForPickup)}/> {gettext('WAITINGFORPICKUP')}</p>
          
          <p><input type="checkbox" checked = {this.state.showOrderOption.pickedUp} onChange={e => this.changeCategoryState('pickedUp', !this.props.showOrderOption.pickedUp)}/> {gettext('PICKEDUP')}</p>
          <p><input type="checkbox" checked = {this.state.showOrderOption.partlyPickedUp} onChange={e => this.changeCategoryState('partlyPickedUp', !this.props.showOrderOption.partlyPickedUp)}/> {gettext('PARTLYPICKEDUP')}</p>

          <p><input type="checkbox" checked = {this.state.showOrderOption.onWayToDelivery} onChange={e => this.changeCategoryState('onWayToDelivery', !this.props.showOrderOption.onWayToDelivery)}/> {gettext('ONWAYTODELIVERY')}</p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showOrderOption: state.dashboardPageReducer.showOrderOption
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MarkerCategoryModal);



// WEBPACK FOOTER //
// ./src/components/maps/markerCategoryModal.js